import React, { Component } from "react";

import { Link } from "react-router-dom";

import { translate } from "react-multi-lang";
import {
  formatMoneyDisplay,
  resolvePaymentSuccessConfirmation,
} from "./checkoutPaymentHelpers";
import "./PaymentSuccess.css";

class PaymentSuccess extends Component {
  getConfirmation = () => {
    var locationState =
      this.props.location && this.props.location.state
        ? this.props.location.state
        : null;
    return resolvePaymentSuccessConfirmation(locationState);
  };

  render() {
    const { t } = this.props;
    var confirmation = this.getConfirmation();

    if (!confirmation) {
      return (
        <div className="payment-success-page">
          <div className="main padding-top-md">
            <div className="top-bottom-spacing">
              <div className="row">
                <div className="col-sm-10 col-md-8 col-lg-6 col-xl-5 auto-margin">
                  <div className="payment-option text-center pt-0">
                    <h3 className="billing-head mb-3">Payment confirmation</h3>
                    <p className="mb-3 payment-success-complete">
                      No payment confirmation is available for this session.
                      If you already completed payment, you can review it in
                      Billing Details.
                    </p>
                    <Link
                      to="/billing-details"
                      className="btn btn-danger mt-1"
                    >
                      Continue to Billing Details
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }

    var amountDisplay = formatMoneyDisplay(
      confirmation.currency,
      confirmation.amount
    );

    return (
      <div className="payment-success-page">
        <div className="main padding-top-md">
          <div className="top-bottom-spacing">
            <div className="row">
              <div className="col-sm-10 col-md-8 col-lg-6 col-xl-5 auto-margin">
                <div className="payment-option text-center pt-0">
                  <img
                    src="../assets/img/success1.gif"
                    className="success-img"
                    alt="payment successful"
                  />
                  <h3 className="billing-head mb-3">Payment Successful</h3>
                  <p className="mb-3 payment-success-complete">
                    Your payment completed and your plan has been updated.
                  </p>
                  <div className="payment-success-summary">
                    <div className="payment-success-summary__row">
                      <span className="payment-success-summary__label">
                        {t("subscription_plan")}
                      </span>
                      <span className="payment-success-summary__value">
                        {confirmation.planTitle || "—"}
                      </span>
                    </div>
                    <div className="payment-success-summary__row">
                      <span className="payment-success-summary__label">
                        Billing term
                      </span>
                      <span className="payment-success-summary__value">
                        {confirmation.planTerm || "—"}
                      </span>
                    </div>
                    <div className="payment-success-summary__row">
                      <span className="payment-success-summary__label">
                        {t("amount")}
                      </span>
                      <span className="payment-success-summary__value">
                        {amountDisplay}
                      </span>
                    </div>
                    <div className="payment-success-summary__row">
                      <span className="payment-success-summary__label">
                        {t("payment_id")}
                      </span>
                      <span className="payment-success-summary__value">
                        {confirmation.payment_id || "—"}
                      </span>
                    </div>
                  </div>
                  <Link
                    to="/billing-details"
                    className="btn btn-danger mt-1"
                  >
                    Continue to Billing Details
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default translate(PaymentSuccess);
